export const statsData = [
  { value: 70, suffix: '', label: 'Familias Conectadas', icon: 'ri-user-heart-line', color: 'primary' },
  { value: 3, suffix: ' km', label: 'Red de Tuberías', icon: 'ri-route-line', color: 'accent' },
  { value: 2015, suffix: '', label: 'Inicio del Servicio', icon: 'ri-calendar-check-line', color: 'secondary' },
  { value: 100, suffix: '%', label: 'Pago Virtual', icon: 'ri-smartphone-line', color: 'primary' },
];

export const quickAccessItems = [
  {
    title: 'Pagar Agua',
    description: 'Realiza el pago de tu servicio de agua de forma virtual, rápida y segura.',
    icon: 'ri-water-flash-line',
    href: '/pagar',
    color: 'primary',
  },
  {
    title: 'Mi Cuenta',
    description: 'Consultá tu deuda, historial de pagos, lecturas y descargá tus recibos.',
    icon: 'ri-user-settings-line',
    href: 'https://codesajancuenta.fluxbostudio.com',
    color: 'accent',
  },
  {
    title: 'Área de Cobertura',
    description: 'Conoce el mapa con la zona exacta donde brindamos servicio de agua.',
    icon: 'ri-map-pin-range-line',
    href: '/cobertura',
    color: 'secondary',
  },
  {
    title: 'Lecturación',
    description: 'Información sobre el proceso de lectura de medidores y cómo reportar tu lectura.',
    icon: 'ri-drop-line',
    href: '/lecturacion',
    color: 'accent',
  },
  {
    title: 'Contacto',
    description: 'Escribinos por WhatsApp para consultas, reclamos o sugerencias sobre el servicio.',
    icon: 'ri-whatsapp-line',
    href: '/contacto',
    color: 'secondary',
  },
  {
    title: 'Nosotros',
    description: 'Conoce la historia, misión y valores de CODESAJAN.',
    icon: 'ri-shield-check-line',
    href: '/nosotros',
    color: 'primary',
  },
];

export const contactInfo = {
  address: 'San Jacinto Norte Zona Oeste, Tarija, Bolivia',
  phoneMobile: '+591 73455233',
  email: 'codesajan.tarija@gmail.com',
  hours: 'Lunes a Viernes: 08:00 - 16:30',
  weekend: 'Sábados: 08:00 - 12:00',
  social: {
    whatsapp: 'https://wa.me/59173455233',
  },
};

export const aboutData = {
  title: 'Comité de Servicios de Agua San Jacinto Norte Zona Oeste',
  subtitle: 'Personería Jurídica N° 056/2011 — Gobernación del Departamento de Tarija',
  description: 'Somos el Comité de Desarrollo San Jacinto Norte Zona Oeste, con personería jurídica otorgada por Resolución Administrativa N° 056/2011 de la Gobernación de Tarija. Como comité autónomo con reglamentación propia, abarcamos dos zonas —área rural y área urbana— de San Jacinto Norte. Desde 2015 brindamos servicio de agua con gestión transparente y compromiso total con nuestras familias afiliadas.',
  values: [
    { title: 'Transparencia', description: 'Gestión clara y abierta de todos nuestros recursos y servicios de agua.', icon: 'ri-shield-check-line' },
    { title: 'Compromiso', description: 'Dedicación total al bienestar de nuestras familias afiliadas y al acceso al agua.', icon: 'ri-hand-heart-line' },
    { title: 'Sostenibilidad', description: 'Conservación responsable de nuestros recursos hídricos y la red de distribución.', icon: 'ri-recycle-line' },
  ],
};

export const servicesData = [
  {
    id: 1,
    title: 'Distribución de Agua',
    description: 'Suministro continuo de agua tratada a las familias de la zona de cobertura de San Jacinto Norte Zona Oeste.',
    icon: 'ri-water-flash-line',
    features: ['Red de distribución de 3 km', 'Tratamiento y cloración', 'Monitoreo de calidad del agua'],
  },
  {
    id: 2,
    title: 'Lecturación de Medidores',
    description: 'Servicio mensual de lectura de medidores de agua con registro preciso del consumo de cada familia.',
    icon: 'ri-drop-line',
    features: ['Lectura mensual', 'Registro digital', 'Notificación de consumo'],
  },
  {
    id: 3,
    title: 'Mantenimiento de Red',
    description: 'Reparaciones, ampliaciones y mantenimiento preventivo de la red de distribución de agua.',
    icon: 'ri-tools-line',
    features: ['Reparación de fugas', 'Ampliación de red', 'Limpieza de reservorios'],
  },
  {
    id: 4,
    title: 'Atención al Usuario',
    description: 'Centro de atención virtual para consultas, reclamos, cambio de titular y otros trámites del servicio de agua.',
    icon: 'ri-customer-service-2-line',
    features: ['Consulta de deuda', 'Cambio de titular', 'Reclamos y sugerencias'],
  },
];

export const galleryImages = [
  { src: 'https://storage.readdy-site.link/project_files/418b164c-f08c-4ba4-9398-9b68655eb361/8a44a0f0-8722-4d38-bf41-fec288e87aea_compressed_DSC_1175.webp', alt: 'Tuberías de agua en cruce de calles', caption: 'Red de distribución en calles principales' },
  { src: 'https://storage.readdy-site.link/project_files/418b164c-f08c-4ba4-9398-9b68655eb361/9640f558-b8db-4493-9fc8-df2d401b9e6c_compressed_DSC_1176.webp', alt: 'Tuberías con trabajador de fondo', caption: 'Trabajos de instalación de red' },
  { src: 'https://storage.readdy-site.link/project_files/418b164c-f08c-4ba4-9398-9b68655eb361/53104011-8cbe-49dc-9f7b-a0d8ee8ed302_compressed_DSC_1181.webp', alt: 'Excavadora trabajando en zanja', caption: 'Excavación para ampliación de red' },
  { src: 'https://storage.readdy-site.link/project_files/418b164c-f08c-4ba4-9398-9b68655eb361/59faced5-80e4-44d7-9c28-44d82ada465a_compressed_DSC_0026_1.webp', alt: 'Excavadora con trabajadores', caption: 'Equipo de trabajo en terreno' },
  { src: 'https://storage.readdy-site.link/project_files/418b164c-f08c-4ba4-9398-9b68655eb361/43ae76a3-7b4c-4745-970c-c6219cad6b6e_compressed_DSC_0029_1.webp', alt: 'Excavadora cargando material', caption: 'Movimiento de tierra para obra' },
  { src: 'https://storage.readdy-site.link/project_files/418b164c-f08c-4ba4-9398-9b68655eb361/aaa91190-24aa-4551-849f-2433fab5f84b_compressed_QR-DE-CANCELACION.webp', alt: 'Código QR de pago virtual', caption: 'Pago virtual por QR' },
];

export const coveragePolygon = [
  [-21.591184, -64.721351],
  [-21.590775, -64.720053],
  [-21.591812, -64.716266],
  [-21.593498, -64.714818],
  [-21.593768, -64.716019],
  [-21.596820, -64.716427],
  [-21.597898, -64.715933],
  [-21.599693, -64.715869],
  [-21.601969, -64.717478],
  [-21.601742, -64.717726],
  [-21.600223, -64.716986],
  [-21.599156, -64.717759],
  [-21.598782, -64.719432],
  [-21.600203, -64.721020],
  [-21.599081, -64.722597],
  [-21.591431, -64.721556],
];